import SelectedTaskButtonHollow from './SelectedTaskButtonHollow';

export default SelectedTaskButtonHollow;
